jQuery(document).ready(function($) {
	/* ------------------ SHARE LINK POP-UP ------------------ */
 var socialShareLinkInit = function () {
   $('header .m-social_media_icon__container .a-logo a').click(function (e) {
     e.preventDefault();
     window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
     return false;
   });
 }

 socialShareLinkInit();

 $(document).bind('ajaxComplete', socialShareLinkInit);
});
